/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sub_Dashboard_Cancel_Downgrade_DescInputs */



/**
* | output |
* | --- |
* | "Your plan will remain unchanged and continue renewing at the current rate." |
*
* @param {Sub_Dashboard_Cancel_Downgrade_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_dashboard_cancel_downgrade_desc = /** @type {((inputs?: Sub_Dashboard_Cancel_Downgrade_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Dashboard_Cancel_Downgrade_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ihr Tarif bleibt unverändert und wird zum aktuellen Preis verlängert.")
	return /** @type {LocalizedString} */ ("Your plan will remain unchanged and continue renewing at the current rate.")
});